import React, { useState } from 'react';

import {
    ProducerSearchFilters,
    ProducerSearchResultsList,
    ProducerSearchResultsMap,
} from '/components/producer-search/components';

const views = {
    LIST: 'list',
    MAP: 'map',
};

const ProducerSearchMobile = ({ activeHit }) => {
    const [view, setView] = useState(views.MAP);

    return (
        <div className={`producer-search-mobile is-${view}-view`}>
            <div className="producer-search-mobile__filters">
                <ProducerSearchFilters />
            </div>
            {view === views.LIST && (
                <div className="producer-search-mobile__results-list">
                    <ProducerSearchResultsList />
                </div>
            )}
            {view === views.MAP && (
                <div className="producer-search-mobile__results-map">
                    <ProducerSearchResultsMap activeHit={activeHit} />
                </div>
            )}
            {false && (
                <div className="producer-search-mobile__view-switcher view-switcher">
                    <button
                        className="view-switcher-button"
                        onClick={() => { setView(views.LIST); }}
                        type="button"
                    >
                        Lijst
                    </button>
                    <button
                        className="view-switcher-button"
                        onClick={() => { setView(views.MAP); }}
                        type="button"
                    >
                        Kaart
                    </button>
                </div>
            )}
        </div>
    );
};

export { ProducerSearchMobile };
